import { buildField } from "../Field";
import { required } from "react-admin";
import { MyField } from "../../components/types";

export interface BaseArgs {
  label: string;
  source: string;
  isRequired?: boolean;
  isFilter?: boolean;
  isCreate?: boolean;
  isEdit?: boolean;
  isUpdate?: boolean;
  isList?: boolean;
  fullWidth?: boolean;
  minWidth?: number;
  maxWidth?: number;
  sortable?: boolean;
}

export function base(args: BaseArgs, fieldSrc: MyField, field?: MyField) {
  const {
    label,
    source,
    isRequired = true,
    isFilter = true,
    isUpdate = true,
    isEdit = true,
    isCreate = true,
    isList = true,
    fullWidth = false,
    sortable = false,
    minWidth,
    maxWidth,
  } = args;

  return buildField(
    {
      label,
      source,
      //
      isFilter,
      isUpdate,
      isEdit,
      isCreate,
      isList,
      fullWidth,
      minWidth,
      maxWidth,
      sortable,
      ...fieldSrc,
      editProps: {
        validate: isRequired ? [required()] : [],
        fullWidth,
        ...fieldSrc.editProps,
      },
    },
    field
  );
}
